import * as React from 'react';

export interface ReactSelectData {
    id?: string,
    customOption?: (rowOBJ: any, disabled: boolean, rowIndex: number) => object,
    css?: string,
    onChange?: (rowOBJ: any, rowIndex: number) => void,
    row: any,
    rowIndex?: number,
    dataKey: string,
    style?: {},
    disabled?: boolean,
    disableID?: string,
    title?: string,
    tabIndex?: null,
}

export interface ReactSelectState {
    row: any,
    disabled: boolean,
}

export class ReactSelect extends React.Component<ReactSelectData> {
    constructor(props: ReactSelectData) {
        super(props);

        this.state = {
            row: props.row,
            disabled: props.disabled
        };

        // Binding is necessary to allow these functions access to the State data
        this.handleChange = this.handleChange.bind(this);
        this.onDisableClick = this.onDisableClick.bind(this);
    }

    // Update the state externally
    componentWillReceiveProps(props: ReactSelectData) {
        this.setState({
            disabled: props.disabled,
            row: props.row,
        });
    }

    handleChange(event: any) {
        const selectedVal = $(event.currentTarget).val();
        this.setState(() => {
            (this.state as ReactSelectState).row[this.props.dataKey] = selectedVal;

            return {
                row: (this.state as ReactSelectState).row
            }
        }, () => {
            if (null != this.props.onChange) {
                this.props.onChange((this.state as ReactSelectState).row, this.props.rowIndex);
            }
        });
    }

    onDisableClick(event: any) {
        const isChecked = $(event.currentTarget).is(":checked");
        this.setState({
            disabled: isChecked
        });
    }

    getSelect() {
        if(this.props.title) {
            return <select
                disabled={(this.state as ReactSelectState).disabled}
                className={this.props.css} id={this.props.id}
                style={this.props.style}
                onChange={this.handleChange}
                title={this.props.title}
                tabIndex={this.props.tabIndex}
            >{(null != this.props.customOption) ? this.props.customOption((this.state as ReactSelectState).row, (this.state as ReactSelectState).disabled, this.props.rowIndex) : null}
            </select>;
        } else {
            return <select
                disabled={(this.state as ReactSelectState).disabled}
                className={this.props.css} id={this.props.id}
                style={this.props.style}
                onChange={this.handleChange}
                tabIndex={this.props.tabIndex}
            >{(null != this.props.customOption) ? this.props.customOption((this.state as ReactSelectState).row, (this.state as ReactSelectState).disabled, this.props.rowIndex) : null}
            </select>;
        }
    }

    render() {
        return <React.Fragment>
            {<table className="categoryAllHide"><tr>
                <td><input
                    id={this.props.disableID}
                    type="checkbox"
                    onChange={this.onDisableClick}
                    checked={(this.state as ReactSelectState).disabled}
                /></td>
                <td>
                    HIDDEN DISABLE Select
                </td>
            </tr></table>
            }
            {this.getSelect()}
        </React.Fragment>
    }
}
